import type { ReactElement, ReactNode } from 'react';

import { StyledTitle } from './Title.styled';

interface TitleProps {
  children: ReactNode;
}

export const Title = ({ children }: TitleProps): ReactElement => (
  <StyledTitle>{children}</StyledTitle>
);
